import { apiClient } from '@/lib/api-client';
import { mentionSuggestionsSchema, type MentionSuggestion } from '@/lib/schemas/mention';

export const mentionsApi = {
  autocomplete: (q: string, signal?: AbortSignal): Promise<MentionSuggestion[]> =>
    apiClient.get('/mentions/autocomplete', mentionSuggestionsSchema, {
      query: { q },
      ...(signal ? { signal } : {}),
    }),
};
